import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["ratingToolSelect", "ratingItemSelect"]

  connect() {
    console.log("Report criteria filter controller connected")
  }

  filterItems(event) {
    const ratingToolId = event.target.value
    const ratingItemSelect = this.ratingItemSelectTarget
    
    if (!ratingToolId) {
      // If no rating tool selected, disable the rating item dropdown
      ratingItemSelect.disabled = true
      ratingItemSelect.innerHTML = '<option value="">First select a rating tool...</option>'
      return
    }

    // Fetch rating items for this rating tool via AJAX
    fetch(`/rating_tools/${ratingToolId}/rating_items.json`)
      .then(response => response.json())
      .then(data => {
        // Clear existing options
        ratingItemSelect.innerHTML = '<option value="">Select a rating item...</option>'
        
        // Add new options
        data.forEach(item => {
          const option = document.createElement('option')
          option.value = item.id
          option.textContent = item.full_name
          ratingItemSelect.appendChild(option)
        })
        
        // Enable the select
        ratingItemSelect.disabled = false
      })
      .catch(error => {
        console.error('Error fetching rating items:', error)
        ratingItemSelect.innerHTML = '<option value="">Error loading items</option>'
      })
  }
}

